(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initializeUniversalProduct(root) {
    if (root.dataset.variantPickerInitialized === 'true') return;

    const form = root.querySelector('[data-product-form]');
    const variantsElement = root.querySelector('[data-product-variants]');
    const variantInput = root.querySelector('[data-variant-id]');
    const optionInputs = [...root.querySelectorAll('[data-option-input]')];
    const price = root.querySelector('[data-current-price]');
    const prepaidPrice = root.querySelector('[data-prepaid-price]');
    const referencePrice = root.querySelector('[data-reference-price]');
    const discountBadge = root.querySelector('[data-discount-badge]');
    const addButton = root.querySelector('[data-add-button]');
    const buyButton = root.querySelector('[data-buy-now]');
    const quantityInput = form?.querySelector('[name="quantity"]');
    const checkoutError = root.querySelector('[data-checkout-error]');
    let checkoutPending = false;
    const availability = root.querySelector('[data-product-availability]');
    const mediaItems = [...root.querySelectorAll('[data-product-media]')];
    const mediaThumbnails = [...root.querySelectorAll('[data-media-thumbnail]')];
    const mediaViewport = root.querySelector('[data-product-media-stage]');
    const thumbnailRail = root.querySelector('[data-product-thumbnails]');
    const mediaFallback = root.querySelector('[data-product-media-fallback]');
    const previousButton = root.querySelector('[data-gallery-previous]');
    const nextButton = root.querySelector('[data-gallery-next]');
    const galleryStatus = root.querySelector('[data-gallery-status]');
    const colorPosition = Number(root.dataset.colorOptionPosition || 0) - 1;

    if (!form || !variantsElement || !variantInput || !addButton) return;

    const variants = JSON.parse(variantsElement.textContent);
    const directColorsByMedia = new Map();
    const colorInputs = colorPosition >= 0
      ? optionInputs.filter((input) => Number(input.dataset.optionPosition) - 1 === colorPosition)
      : [];
    const colorValues = colorInputs.map((input) => input.value);
    const mediaMetadata = new Map();
    const sharedMediaIds = new Set();
    let currentGalleryColor;
    let allowedMediaIds = new Set();
    let currentMediaId;
    let scrollFrame;
    let scrollTimer;
    let dragState;
    let suppressClick = false;

    function normalizeValue(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function readMediaMetadata(alt) {
      const metadata = { shared: false, color: '' };
      const tokenPattern = /\[navyoro:(shared|color\s*=\s*([^\]]+))\]/gi;
      let match;

      while ((match = tokenPattern.exec(String(alt || ''))) !== null) {
        if (match[1].toLowerCase() === 'shared') metadata.shared = true;
        if (match[2]) metadata.color = normalizeValue(match[2]);
      }
      return metadata;
    }

    mediaItems.forEach((item) => {
      const metadata = readMediaMetadata(item.dataset.mediaAlt);
      if (item.hasAttribute('data-shared-media')) metadata.shared = true;
      mediaMetadata.set(item.dataset.mediaId, metadata);
      if (metadata.shared) sharedMediaIds.add(item.dataset.mediaId);
    });

    function mediaPriority(item) {
      if (!item) return 0;
      if (item.hasAttribute('data-size-chart-media')) return 2;
      return sharedMediaIds.has(item.dataset.mediaId) ? 1 : 0;
    }

    mediaItems.sort((first, second) => mediaPriority(first) - mediaPriority(second));
    mediaItems.forEach((item) => mediaViewport?.insertBefore(item, mediaFallback));
    mediaThumbnails.sort((first, second) => {
      const firstMedia = mediaItems.find((item) => item.dataset.mediaId === first.dataset.mediaId);
      const secondMedia = mediaItems.find((item) => item.dataset.mediaId === second.dataset.mediaId);
      return mediaPriority(firstMedia) - mediaPriority(secondMedia);
    });
    mediaThumbnails.forEach((thumbnail) => thumbnailRail?.append(thumbnail));

    variants.forEach((variant) => {
      if (!variant.featuredMediaId || colorPosition < 0) return;
      const mediaId = String(variant.featuredMediaId);
      const color = normalizeValue(variant.options[colorPosition]);
      if (!directColorsByMedia.has(mediaId)) directColorsByMedia.set(mediaId, new Set());
      directColorsByMedia.get(mediaId).add(color);
    });

    const colorSpecificMedia = mediaItems.filter((item) => !sharedMediaIds.has(item.dataset.mediaId));
    const inferredMediaByColor = new Map(colorValues.map((color) => [normalizeValue(color), new Set()]));
    const mediaColorOrder = colorSpecificMedia
      .slice(0, colorValues.length)
      .map((media) => {
        const directColors = [...(directColorsByMedia.get(media.dataset.mediaId) || [])];
        return directColors.length === 1 ? directColors[0] : '';
      });
    const hasSequentialAnchor = colorValues.length > 0
      && mediaColorOrder.length === colorValues.length
      && mediaColorOrder.every(Boolean)
      && new Set(mediaColorOrder).size === colorValues.length
      && colorValues.every((color) => mediaColorOrder.includes(normalizeValue(color)));

    if (hasSequentialAnchor) {
      const completeBlocks = Math.floor(colorSpecificMedia.length / colorValues.length);
      for (let index = 0; index < completeBlocks * colorValues.length; index += 1) {
        const mediaId = colorSpecificMedia[index].dataset.mediaId;
        const expectedColor = mediaColorOrder[index % mediaColorOrder.length];
        const directColors = directColorsByMedia.get(mediaId);
        const metadata = mediaMetadata.get(mediaId);
        if (!metadata.shared && !metadata.color && (!directColors || directColors.has(expectedColor))) {
          inferredMediaByColor.get(expectedColor).add(mediaId);
        }
      }
    }

    root.dataset.variantPickerInitialized = 'true';

    function selectedOptions() {
      const values = [];
      optionInputs.forEach((input) => {
        if (input.checked) values[Number(input.dataset.optionPosition) - 1] = input.value;
      });
      return values;
    }

    function findVariant(options) {
      return variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    function setOptionsFromVariant(variant) {
      optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        input.checked = input.value === variant.options[position];
      });
    }

    function bestAvailableVariantForColor(options) {
      const color = options[colorPosition];
      const candidates = variants.filter((variant) => variant.available && variant.options[colorPosition] === color);
      return candidates.reduce((best, variant) => {
        const score = variant.options.reduce((total, value, index) => {
          if (index === colorPosition) return total;
          return total + Number(value === options[index]);
        }, 0);
        if (!best || score > best.score) return { variant, score };
        return best;
      }, null)?.variant;
    }

    function optionCanBePurchased(input, options) {
      const position = Number(input.dataset.optionPosition) - 1;

      if (colorPosition >= 0) {
        return variants.some((variant) => {
          if (!variant.available || variant.options[position] !== input.value) return false;
          if (position === colorPosition) return true;
          return variant.options[colorPosition] === options[colorPosition];
        });
      }

      const candidate = [...options];
      candidate[position] = input.value;
      return variants.some((variant) => {
        if (!variant.available) return false;
        return variant.options.every((value, index) => !candidate[index] || value === candidate[index]);
      });
    }

    function updateOptionState(options) {
      optionInputs.forEach((input) => {
        input.disabled = !optionCanBePurchased(input, options);
        input.nextElementSibling?.setAttribute('aria-disabled', String(input.disabled));
      });

      root.querySelectorAll('[data-product-option-group]').forEach((group) => {
        const selected = group.querySelector('[data-option-input]:checked');
        const label = group.querySelector('[data-selected-option]');
        if (label && selected) label.textContent = selected.value;
      });
    }

    function mediaIdsForColor(color, variant) {
      const normalizedColor = normalizeValue(color);
      const colorMediaIds = new Set();

      mediaItems.forEach((item) => {
        const metadata = mediaMetadata.get(item.dataset.mediaId);
        if (metadata.shared) return;
        if (metadata.color) {
          if (metadata.color === normalizedColor) colorMediaIds.add(item.dataset.mediaId);
          return;
        }

        const directColors = directColorsByMedia.get(item.dataset.mediaId);
        if (directColors?.has(normalizedColor)) {
          colorMediaIds.add(item.dataset.mediaId);
          return;
        }
        if (inferredMediaByColor.get(normalizedColor)?.has(item.dataset.mediaId)) colorMediaIds.add(item.dataset.mediaId);
      });

      if (colorMediaIds.size === 0 && variant?.featuredMediaId) colorMediaIds.add(String(variant.featuredMediaId));

      return new Set(
        mediaItems
          .filter((item) => colorMediaIds.has(item.dataset.mediaId) || sharedMediaIds.has(item.dataset.mediaId))
          .map((item) => item.dataset.mediaId)
      );
    }

    function visibleMediaItems() {
      return mediaItems.filter((item) => !item.hidden);
    }

    function slideLabel(index, total) {
      return root.dataset.slideLabelTemplate
        .replace('[current]', String(index + 1))
        .replace('[total]', String(total));
    }

    function updateNavigation() {
      const visibleItems = visibleMediaItems();
      const currentIndex = visibleItems.findIndex((item) => item.dataset.mediaId === currentMediaId);
      const hasMultiple = visibleItems.length > 1;

      if (previousButton) {
        previousButton.hidden = !hasMultiple;
        previousButton.disabled = currentIndex <= 0;
      }
      if (nextButton) {
        nextButton.hidden = !hasMultiple;
        nextButton.disabled = currentIndex < 0 || currentIndex >= visibleItems.length - 1;
      }

      visibleItems.forEach((item, index) => {
        item.setAttribute('aria-label', slideLabel(index, visibleItems.length));
      });
      if (galleryStatus && currentIndex >= 0) galleryStatus.textContent = slideLabel(currentIndex, visibleItems.length);
    }

    function selectMedia(mediaId, scrollToMedia = true) {
      const activeMedia = mediaItems.find((item) => item.dataset.mediaId === String(mediaId) && allowedMediaIds.has(item.dataset.mediaId));
      if (!activeMedia) return false;

      mediaItems.forEach((item) => {
        const isActive = item === activeMedia;
        item.classList.toggle('is-active', isActive);
        if (!isActive) item.querySelector('video')?.pause();
      });

      mediaThumbnails.forEach((thumbnail) => {
        const isActive = thumbnail.dataset.mediaId === activeMedia.dataset.mediaId;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', String(isActive));
      });

      currentMediaId = activeMedia.dataset.mediaId;
      updateNavigation();
      if (scrollToMedia && mediaViewport) {
        mediaViewport.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
      }
      mediaThumbnails.find((thumbnail) => thumbnail.dataset.mediaId === currentMediaId)
        ?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      return true;
    }

    function updateGallery(variant, options) {
      const selectedColor = colorPosition >= 0 ? options[colorPosition] : '__all__';
      if (selectedColor === currentGalleryColor) return;
      currentGalleryColor = selectedColor;
      allowedMediaIds = colorPosition >= 0
        ? mediaIdsForColor(selectedColor, variant)
        : new Set(mediaItems.map((item) => item.dataset.mediaId));

      mediaItems.forEach((item) => {
        item.hidden = !allowedMediaIds.has(item.dataset.mediaId);
        item.classList.remove('is-active');
      });
      mediaThumbnails.forEach((thumbnail) => {
        thumbnail.hidden = !allowedMediaIds.has(thumbnail.dataset.mediaId);
        thumbnail.classList.remove('is-active');
        thumbnail.setAttribute('aria-current', 'false');
      });

      const visibleThumbnails = mediaThumbnails.filter((thumbnail) => !thumbnail.hidden);
      if (thumbnailRail) thumbnailRail.hidden = visibleThumbnails.length <= 1;

      const firstMediaId = mediaItems.find((item) => allowedMediaIds.has(item.dataset.mediaId))?.dataset.mediaId;
      if (mediaViewport) mediaViewport.scrollTo({ left: 0, behavior: 'auto' });
      const hasMedia = firstMediaId && selectMedia(firstMediaId, false);

      if (mediaFallback) mediaFallback.hidden = Boolean(hasMedia);
      if (!hasMedia) mediaItems.forEach((item) => { item.hidden = true; });
      updateNavigation();
    }

    function moveGallery(direction) {
      const visibleItems = visibleMediaItems();
      const currentIndex = visibleItems.findIndex((item) => item.dataset.mediaId === currentMediaId);
      const nextIndex = Math.max(0, Math.min(visibleItems.length - 1, currentIndex + direction));
      if (nextIndex !== currentIndex) selectMedia(visibleItems[nextIndex].dataset.mediaId);
    }

    function syncMediaFromScroll() {
      if (!mediaViewport || dragState) return;
      const visibleItems = visibleMediaItems();
      if (!visibleItems.length) return;
      const closest = visibleItems.reduce((best, item) => {
        const distance = Math.abs(item.offsetLeft - mediaViewport.scrollLeft);
        return !best || distance < best.distance ? { item, distance } : best;
      }, null);
      if (closest?.item.dataset.mediaId !== currentMediaId) selectMedia(closest.item.dataset.mediaId, false);
    }

    function updatePrice(variant) {
      if (!variant || !price || !referencePrice) return;
      price.textContent = variant.price;
      if (prepaidPrice) prepaidPrice.textContent = variant.prepaidPrice;
      referencePrice.textContent = variant.referencePrice;
      if (discountBadge) discountBadge.textContent = variant.discountLabel;
    }

    function updateAvailability(variant) {
      if (!variant || !availability) return;
      const threshold = Number(availability.dataset.lowStockThreshold || 0);
      const isLowStock = variant.available && variant.inventoryManagement && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= threshold;

      if (!variant.available) {
        availability.textContent = availability.dataset.soldOutText;
      } else if (isLowStock) {
        availability.textContent = availability.dataset.lowStockTemplate.replace('[count]', variant.inventoryQuantity);
      } else {
        availability.textContent = availability.dataset.inStockText;
      }
    }

    function updateUrl(variant) {
      if (!variant || !window.history.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    function initializeReviewSummary() {
      const reviewSummary = root.querySelector('[data-product-review-summary]');
      if (!reviewSummary) return;

      reviewSummary.addEventListener('click', (event) => {
        const reviewWidget = document.getElementById('judgeme_product_reviews');
        if (!reviewWidget) return;
        event.preventDefault();
        reviewWidget.setAttribute('tabindex', '-1');
        reviewWidget.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
        reviewWidget.focus({ preventScroll: true });
      });
    }

    function initializeDescriptionToggle() {
      const description = root.querySelector('[data-product-description]');
      const content = root.querySelector('[data-product-description-content]');
      const toggle = root.querySelector('[data-product-description-toggle]');
      if (!description || !content || !toggle) return;

      const moreLabel = toggle.querySelector('[data-product-description-more]');
      const lessLabel = toggle.querySelector('[data-product-description-less]');
      let expanded = false;

      function updateHeight() {
        content.style.setProperty('--product-description-full-height', `${content.scrollHeight}px`);
      }

      function setExpanded(nextExpanded) {
        expanded = nextExpanded;
        updateHeight();
        content.classList.toggle('is-collapsed', !expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        if (moreLabel) moreLabel.hidden = expanded;
        if (lessLabel) lessLabel.hidden = !expanded;
      }

      function evaluate() {
        content.classList.remove('is-collapsed');
        updateHeight();
        const collapsedHeight = Number.parseFloat(getComputedStyle(content).getPropertyValue('--product-description-collapsed-height')) || 288;
        const needsToggle = content.scrollHeight > collapsedHeight + 8;
        toggle.hidden = !needsToggle;
        if (needsToggle) setExpanded(expanded);
      }

      toggle.addEventListener('click', () => setExpanded(!expanded));
      window.requestAnimationFrame(evaluate);
      window.addEventListener('resize', evaluate, { passive: true });
    }

    function synchronize(changedPosition = null) {
      let options = selectedOptions();
      let variant = optionInputs.length
        ? findVariant(options)
        : variants.find((item) => String(item.id) === String(variantInput.value)) || variants[0];

      if (changedPosition === colorPosition && (!variant || !variant.available)) {
        const availableVariant = bestAvailableVariantForColor(options);
        if (availableVariant) {
          setOptionsFromVariant(availableVariant);
          options = selectedOptions();
          variant = availableVariant;
        }
      }

      updateOptionState(options);

      if (!variant) {
        variantInput.value = '';
        addButton.disabled = true;
        if (buyButton) buyButton.disabled = true;
        addButton.textContent = addButton.dataset.soldText;
        return;
      }

      variantInput.value = variant.id;
      addButton.disabled = !variant.available || checkoutPending;
      if (buyButton) buyButton.disabled = !variant.available || checkoutPending || !quantityInput.checkValidity();
      addButton.textContent = variant.available ? addButton.dataset.availableText : addButton.dataset.soldText;
      updatePrice(variant);
      updateAvailability(variant);
      updateGallery(variant, options);
      updateUrl(variant);
    }

    mediaThumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => selectMedia(thumbnail.dataset.mediaId));
    });
    previousButton?.addEventListener('click', () => moveGallery(-1));
    nextButton?.addEventListener('click', () => moveGallery(1));
    mediaViewport?.addEventListener('keydown', (event) => {
      if (event.target.closest('video, model-viewer, iframe, input, select, textarea')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        moveGallery(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        moveGallery(1);
      }
    });
    mediaViewport?.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      window.clearTimeout(scrollTimer);
      scrollFrame = window.requestAnimationFrame(syncMediaFromScroll);
      scrollTimer = window.setTimeout(syncMediaFromScroll, 120);
    }, { passive: true });
    mediaViewport?.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('video, model-viewer, iframe, button, input, select, textarea')) return;
      dragState = { pointerId: event.pointerId, startX: event.clientX, startScroll: mediaViewport.scrollLeft, moved: false };
      mediaViewport.setPointerCapture(event.pointerId);
    });
    mediaViewport?.addEventListener('pointermove', (event) => {
      if (!dragState || dragState.pointerId !== event.pointerId) return;
      const distance = event.clientX - dragState.startX;
      if (Math.abs(distance) > 5) dragState.moved = true;
      if (!dragState.moved) return;
      mediaViewport.classList.add('is-dragging');
      mediaViewport.scrollLeft = dragState.startScroll - distance;
    });
    function finishDrag(event) {
      if (!dragState || dragState.pointerId !== event.pointerId) return;
      suppressClick = dragState.moved;
      dragState = null;
      mediaViewport.classList.remove('is-dragging');
      syncMediaFromScroll();
      const activeMedia = mediaItems.find((item) => item.dataset.mediaId === currentMediaId);
      if (activeMedia) mediaViewport.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
    }
    mediaViewport?.addEventListener('pointerup', finishDrag);
    mediaViewport?.addEventListener('pointercancel', finishDrag);
    mediaViewport?.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
    optionInputs.forEach((input) => {
      input.addEventListener('change', () => synchronize(Number(input.dataset.optionPosition) - 1));
    });
    if (buyButton) {
      quantityInput.required = true;
      quantityInput.step = '1';
      quantityInput.addEventListener('input', () => {
        const variant = variants.find((item) => String(item.id) === variantInput.value);
        buyButton.disabled = checkoutPending || !variant?.available || !quantityInput.checkValidity();
      });
      window.addEventListener('pageshow', () => {
        checkoutPending = false;
        form.removeAttribute('aria-busy');
        buyButton.textContent = buyButton.dataset.availableText;
        synchronize();
      });
    }
    form.addEventListener('submit', async (event) => {
      if (!variantInput.value || addButton.disabled || checkoutPending) {
        event.preventDefault();
        return;
      }
      if (!buyButton || event.submitter !== buyButton) return;
      event.preventDefault();
      if (buyButton.disabled || !form.reportValidity()) return;
      const body = new FormData(form);
      body.delete('return_to');
      checkoutPending = true;
      form.setAttribute('aria-busy', 'true');
      buyButton.disabled = true;
      addButton.disabled = true;
      buyButton.textContent = buyButton.dataset.loadingText;
      checkoutError.hidden = true;
      const routeRoot = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(`${routeRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || buyButton.dataset.errorText);
        window.location.assign(`${routeRoot}cart?navyoro_buy_now=1`);
      } catch (error) {
        checkoutError.textContent = error.message || buyButton.dataset.errorText;
        checkoutError.hidden = false;
        checkoutPending = false;
        form.removeAttribute('aria-busy');
        buyButton.textContent = buyButton.dataset.availableText;
        synchronize();
      }
    });
    initializeReviewSummary();
    initializeDescriptionToggle();
    synchronize();
  }

  document.querySelectorAll('[data-universal-product]').forEach(initializeUniversalProduct);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-universal-product]').forEach(initializeUniversalProduct);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function setupRelatedCarousel(section){
    if(!section) return;
    const track=section.querySelector('[data-related-track]');
    if(!track) return;
    const prev=section.querySelector('[data-related-prev]');
    const next=section.querySelector('[data-related-next]');
    const getStep=()=>{
      const item=track.querySelector('.product-recommendations__item');
      if(!item) return track.clientWidth;
      const styles=getComputedStyle(track);
      const gap=parseFloat(styles.columnGap||styles.gap||0)||0;
      return item.getBoundingClientRect().width+gap;
    };
    const update=()=>{
      if(prev) prev.disabled=track.scrollLeft<=2;
      if(next) next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
    };
    if(prev && !prev.dataset.bound){prev.dataset.bound='1';prev.addEventListener('click',()=>track.scrollBy({left:-getStep(),behavior:'smooth'}));}
    if(next && !next.dataset.bound){next.dataset.bound='1';next.addEventListener('click',()=>track.scrollBy({left:getStep(),behavior:'smooth'}));}
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  }

  function initializeProductRecommendations(section){
    if(!section || section.dataset.recommendationsInitialized==='true') return;
    section.dataset.recommendationsInitialized='true';
    const loadRecommendations=()=>{
      const url=section.dataset.url;
      if(!url) return;
      fetch(url)
        .then((response)=>{if(!response.ok) throw new Error('Unable to load related products.');return response.text();})
        .then((text)=>{
          const response=document.createElement('div');
          response.innerHTML=text;
          const renderedSection=response.querySelector('[data-product-recommendations]');
          if(renderedSection?.innerHTML.trim()){
            section.innerHTML=renderedSection.innerHTML;
            setupRelatedCarousel(section);
          }else{section.remove();}
        })
        .catch(()=>section.remove());
    };
    if(section.querySelector('[data-related-track]')) setupRelatedCarousel(section);
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver((entries)=>{if(!entries.some((entry)=>entry.isIntersecting)) return;observer.disconnect();loadRecommendations();},{rootMargin:'0px 0px 320px 0px'});
      observer.observe(section);
    }else{loadRecommendations();}
  }

  document.querySelectorAll('[data-product-recommendations]').forEach(initializeProductRecommendations);
  document.addEventListener('shopify:section:load',(event)=>{event.target.querySelectorAll('[data-product-recommendations]').forEach(initializeProductRecommendations);});

  } catch(e) { console.error(e); }
})();
})();
